const profileEditRequests = {
  pageTitle: "طلبات تعديل الملف",
  listBreadcrumb: "طلبات تعديل الملف",
  searchPlaceholder: "بحث باسم الشركة",
  statusFilterLabel: "الحالة",
  statusOptions: {
    pending: "جديد",
    in_review: "تم فتحه",
    approved: "مقبول",
    rejected: "مرفوض",
  },
  columns: {
    company: "الشركة",
    requestedBy: "مقدَّم من",
    requestDate: "تاريخ الطلب",
    requestStatus: "حالة الطلب",
    editedFields: "الحقول المعدلة",
  },
  showingRange: "عرض {from}–{to} من {total} طلب",
  emptyTitle: "لا توجد طلبات تعديل ملف",
  emptyDescription: "ستظهر هنا الطلبات المقدَّمة من الشركات.",
};

export default profileEditRequests;
